<template>
  <div class="card shadow"
       :class="[type === 'dark' ? 'bg-default': '',{loading:carregando}]">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col text-right">
        <!--
            <router-link to="/parametros/novo">
                <base-button type="default" class="ml-4">Novo grupo</base-button>
            </router-link>
            -->
        </div>
      </div>
    </div>

    <div class="table-responsive" v-if="!carregando">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="itensPagina">
        <template slot="columns">
          <th>Nome</th>
          <th>Parâmetros</th>
          <th></th>
        </template>

        <template slot-scope="{row}" :index="row.id">
          <th scope="row">
            <span class="name mb-0 text-sm">{{row.nomeGrupo}}</span>
          </th>
          <td>
            {{JSON.parse(row.definicoes).length}}
          </td>

          <td class="botoes text-right">
            <base-button :to="'/parametros/'+row.id" type="default" icon="fas fa-edit" size="sm"></base-button>
            <base-button @click="preparaExclusao(row)" type="danger" icon="fas fa-trash" size="sm" class="ml-2"></base-button>
          </td>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end" v-if="paginacao.porPagina < tableData.length"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination :perPage="paginacao.porPagina" v-model="paginacao.pagina" :total="tableData.length"></base-pagination>
    </div>

    <modal :show.sync="exclusao.modal"
            gradient="danger"
            modal-classes="modal-danger modal-dialog-centered"
            v-if="exclusao.alvo">
        <h6 slot="header" class="modal-title" id="modal-title-notification">Excluindo '{{exclusao.alvo.nomeGrupo}}'</h6>

        <div class="py-3 text-center">
            <i class="fas fa-exclamation-triangle fa-3x"></i>
            <h4 class="heading mt-4">ATENÇÃO</h4>
            <p>Você tem certeza de que deseja excluir este grupo de parâmetros?</p>
            <p>Os valores utilizados a partir deste grupo não serão mais listados e podem não ser mais acessíveis dependendo de seu uso.</p>
        </div>

        <template slot="footer">
            <base-button @click="excluirFeed" type="white">Sim, remover</base-button>
            <base-button type="link"
                          text-color="white"
                          class="ml-auto"
                          @click="exclusao.modal = false">
                Cancelar
            </base-button>
        </template>
    </modal>
  </div>
</template>
<script>
  import parametros from "@/cflow/parametros.js";
  import helpers from "@/cflow/helpers";
  export default {
    props: {
      type: {
        type: String
      },
      title: String
    },
    methods:{
        preparaExclusao: function(objeto){
          // Abre o modal e salva qual video tá tentando excluir
          this.exclusao.alvo = objeto;
          this.exclusao.modal = true;
        },
        excluirFeed: function(){
          var app = this;
          parametros.delete(this.exclusao.alvo.id).then( function() {
            // Buscar o item na array de dados e remover ele:
            for(var i in app.tableData){
              if(app.tableData[i].id == app.exclusao.alvo.id) app.tableData.splice(i,1);
            }
            // Ocultar o modal e limpar os dados
            app.exclusao.modal=false;
            app.exclusao.alvo=null;
          } );
        }
    },
    computed:{
      itensPagina(){
        // Aqui vai automaticamente pegar apenas os itens que deveriam estar na página e retornar eles como itensPagina
        const start = (this.paginacao.pagina-1)*this.paginacao.porPagina,
              end = start + this.paginacao.porPagina;
        return this.tableData.slice(start,end);
      }
    },
    data() {
      return {
        tableData: [],
        carregando: false,
        paginacao:{
          porPagina: 20,
          pagina: 1
        },
        exclusao:{
          modal: false,
          alvo: null
        }
      }
    },
    mounted(){
      var app = this;
      app.carregando = true;

      // Solicitar os videos no banco:
      parametros.listar().then( res => {
        app.tableData = res;
        app.carregando = false;
      }).catch( error =>{
        helpers.mostrarErros(null,error.response.data,this);
        app.carregando = false;
      } );
    }
  }
</script>
<style>
</style>
